import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./components/Homepage"; 
import EarlyBird from "./components/EarlyBird";
import Mission from "./components/Mission";
import TheIndependent from "./components/TheIndependent";

function App() {
  return (
    <Router>
      <Routes>
        {/* Homepage route */}
        <Route path="/" element={<Homepage />} />
        {/* EarlyBird route */}
        <Route path="/early-bird" element={<EarlyBird />} />
        
        
        {/* Mission route */}
        <Route path="/mission" element={<Mission />} />
        {/* The Independent route */}
        <Route path="/the-independent" element={<TheIndependent />} />
        
        
        {/* /test route with backend message */}
        
      </Routes>
    </Router>
  );
}

export default App;
